import { createContext, useContext, useState } from 'react';

const ProfileContext = createContext(null);

export function ProfileProvider({ children }) {
  const [profiles, setProfiles] = useState([]);
  const [activeProfileId, setActiveProfileId] = useState(null);

  const addProfile = (profile) => {
    setProfiles(prev => [...prev, profile]);
    setActiveProfileId(profile?.id ?? null);
    return profile;
  };

  const updateProfileWidth = (id, width) => {
    let updated = null;
    setProfiles(prev => prev.map((p) => {
      if (p.id !== id) return p;
      const next = { ...p, width };
      if (next.model && typeof next.model.updateWidth === 'function') {
        next.model.updateWidth(width);
      }
      updated = next;
      return next;
    }));
    return updated;
  };

  const updateProfileOffset = (id, delta) => {
    let updated = null;
    setProfiles(prev => prev.map((p) => {
      if (p.id !== id) return p;
      const next = { ...p };
      if (next.model && typeof next.model.updateOffset === 'function') {
        next.model.updateOffset(delta);
      }
      updated = next;
      return next;
    }));
    return updated;
  };

  const updateProfilePointOffset = (id, which, delta) => {
    let updated = null;
    setProfiles(prev => prev.map((p) => {
      if (p.id !== id) return p;
      const next = { ...p };
      if (next.model && typeof next.model.updatePointOffset === 'function') {
        next.model.updatePointOffset(which, delta);
      }
      updated = next;
      return next;
    }));
    return updated;
  };

  const deleteProfile = (id) => {
    setProfiles(prev => {
      const next = prev.filter(p => p.id !== id);
      setActiveProfileId(aid =>
        aid === id ? (next.length ? next[next.length - 1].id : null) : aid
      );
      return next;
    });
  };

  const setActive = (id) => setActiveProfileId(id);

  const clearProfiles = () => {
    setProfiles([]);
    setActiveProfileId(null);
  };

  return (
    <ProfileContext.Provider value={{
      profiles,
      activeProfileId,
      addProfile,
      updateProfileWidth,
      updateProfileOffset,
      updateProfilePointOffset,
      deleteProfile,
      setActive,
      clearProfiles,
    }}>
      {children}
    </ProfileContext.Provider>
  );
}

export function useProfileContext() {
  const ctx = useContext(ProfileContext);
  if (!ctx) throw new Error('useProfileContext must be used inside ProfileProvider');
  return ctx;
}
